(function () {
  function detectDiscountWrap() {
    const container = document.querySelector('.cart-drawer .discount_price-container');
    const discount = container?.querySelector('.discount_discount-value');
    const price = container?.querySelector('.totals__total-value');

    if (!container || !discount || !price) return;
    const discountTop = discount.getBoundingClientRect().top;
    const priceTop = price.getBoundingClientRect().top;
    if (discountTop + 5 < priceTop) {
      container.classList.add('wrap');
    } else {
      container.classList.remove('wrap');
    }
  }

  function handleProductUpsellToggle(input, formId) {
    const form = document.getElementById(formId);
    const variantId = form.querySelector('input[name="id"]').value;

    if (input.checked) {
      // If turning ON, use existing Add function
      handleProductUpsellAdd(input, formId);
    } else {
      // If turning OFF, remove the item
      input.closest('.upsell-product-container').classList.add('is-loading');
      
      // Target the custom cart element
      const cartDrawer = document.querySelector('cart-drawer');
      // Get the specific section IDs the drawer needs to re-render
      const sections = cartDrawer.getSectionsToRender().map((section) => section.id);
      
      window.CartApi
        .change({
          id: variantId.toString(),
          quantity: 0,
          sections: sections,
          sections_url: window.location.pathname
        })
        .then(response => response.json())
        .then(parsedState => {
          if (cartDrawer) {
            cartDrawer.renderContents(parsedState);
          }
        })
        .catch(error => console.error('Error:', error))
        .finally(() => {
          input.closest('.upsell-product-container').classList.remove('is-loading');
        });
    }
  }

  function handleCompactToggle(btn) {
    var isToggled = btn.classList.contains('upsell-compact-toggled');
    var formId = btn.dataset.formId;
    var variantId = btn.dataset.variantId;

    if (isToggled) {
      btn.classList.add('is-loading');
      var cartDrawer = document.querySelector('cart-drawer');
      var sections = cartDrawer.getSectionsToRender().map(function(s) { return s.id; });

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId.toString(),
          quantity: 0,
          sections: sections,
          sections_url: window.location.pathname
        })
      })
      .then(function(r) { return r.json(); })
      .then(function(parsedState) {
        if (cartDrawer) cartDrawer.renderContents(parsedState);
      })
      .catch(function(e) { console.error('Error:', e); })
      .finally(function() { btn.classList.remove('is-loading'); });
    } else {
      handleProductUpsellAdd(btn, formId);
    }
  }

  // Earlier deferred scripts (cart.js, upsell-simple.js) keep their versions, as when this ran inline first.
  var globals = { detectDiscountWrap: detectDiscountWrap, handleProductUpsellToggle: handleProductUpsellToggle, handleCompactToggle: handleCompactToggle };
  Object.keys(globals).forEach(function (name) {
    if (typeof window[name] !== 'function') window[name] = globals[name];
  });

  document.addEventListener('DOMContentLoaded', function () {
    window.detectDiscountWrap();
  });
})();
